var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.content_type,_vm._b({tag:"component",model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'component',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }